<template>
  <div :class="`tooltip ${position}`">
    <slot></slot>
    <span class="tooltip-text">
      <span v-if="name!=='ToolTipDefaultName'">
        <strong>姓名:</strong>
      </span>
      <span v-if="name!=='ToolTipDefaultName'">{{name}}</span>
      <span v-if="name!=='ToolTipDefaultName'">
        <br />
      </span>
      <span v-if="id!=='ToolTipDefaultID'">
        <strong>身分證:</strong>
        {{id}}
        <br />
      </span>
      <span v-if="mobile!=='ToolTipDefaultMobile'">
        <strong>手機:</strong>
        {{mobile}}
        <br />
      </span>
      <span v-if="phone!=='ToolTipDefaultPhone'">
        <strong>電話:</strong>
        {{phone}}
        <br />
      </span>
      <span v-if="birthday!=='ToolTipDefaultBirthday'">
        <strong>生日:</strong>
        <span v-if="this.checkDateFormat(birthday)">{{birthday}}</span>
        <span v-else>{{birthday | dateFormat}}</span>
        <br />
      </span>
      <span v-if="address!=='ToolTipDefaultAddress'">
        <strong>住家地址:</strong>
        {{address}}
        <br />
      </span>
      <span v-if="company_address!=='ToolTipDefaultCompanyAddress'">
        <strong>公司地址:</strong>
        {{company_address}}
        <br />
      </span>
      <span v-if="expense_address!=='ToolTipDefaultExpenseAddress'">
        <strong>收費地址:</strong>
        {{expense_address}}
        <br />
      </span>
      <!-- 20210624 MV個資遮蔽新增戶長欄位 -->
      <span v-if="houseHolder!=='ToolTipDefaultHouseHolder'">
        <strong>戶長:</strong>
        {{houseHolder}}
        <br />
      </span>
      <!-- 20210625 MV個資遮蔽新增年齡(生日)欄位 -->
      <!-- <span v-if="mvAgeAndBirthday!=='ToolTipDefaultMvAgeAndBirthday'">
        <strong>年齡:</strong>
        {{mvAgeAndBirthday}}
        <br />
      </span>-->
      <!-- 20210625 MV個資遮蔽新增ID欄位 -->
      <!-- <span v-if="mvId!=='ToolTipDefaultMvId'">
        <strong>ID:</strong>
        {{mvId}}
        <br />
      </span>-->
      <span v-if="insd_name!=='ToolTipDefaultInsdName'">
        <strong>被保人姓名:</strong>
        {{insd_name}}
        <br />
      </span>
      <span v-if="insd_id!=='ToolTipDefaultInsdID'">
        <strong>被保人身分證:</strong>
        {{insd_id}}
        <br />
      </span>
      <!--擴充欄位區塊-->
      <span v-if="expand_col1!=='expand_col1'">
        <strong>{{expand_col1}}:</strong>
        {{expand_col1_value}}
        <br />
      </span>
      <span v-if="expand_col2!=='expand_col2'">
        <strong>{{expand_col2}}:</strong>
        {{expand_col2_value}}
        <br />
      </span>
      <span v-if="expand_col3!=='expand_col3'">
        <strong>{{expand_col3}}:</strong>
        {{expand_col3_value}}
        <br />
      </span>
      <span v-if="expand_col4!=='expand_col4'">
        <strong>{{expand_col4}}:</strong>
        {{expand_col4_value}}
        <br />
      </span>
      <span v-if="expand_col5!=='expand_col5'">
        <strong>{{expand_col5}}:</strong>
        {{expand_col5_value}}
        <br />
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    position: String,
    name: { type: String, default: "ToolTipDefaultName" },
    id: { type: String, default: "ToolTipDefaultID" },
    mobile: { type: String, default: "ToolTipDefaultMobile" },
    phone: { type: String, default: "ToolTipDefaultPhone" },
    birthday: { type: String, default: "ToolTipDefaultBirthday" },
    address: { type: String, default: "ToolTipDefaultAddress" },
    company_address: { type: String, default: "ToolTipDefaultCompanyAddress" },
    expense_address: { type: String, default: "ToolTipDefaultExpenseAddress" },
    houseHolder: { type: String, default: "ToolTipDefaultHouseHolder" },
    // mvAgeAndBirthday: { type: String, default: "ToolTipDefaultMvAgeAndBirthday" },
    // mvId: { type: String, default: "ToolTipDefaultMvId" },
    insd_name: { type: String, default: "ToolTipDefaultInsdName" },
    insd_id: { type: String, default: "ToolTipDefaultInsdID" },
    //擴充欄位
    expand_col1: { type: String, default: "expand_col1" },
    expand_col2: { type: String, default: "expand_col2" },
    expand_col3: { type: String, default: "expand_col3" },
    expand_col4: { type: String, default: "expand_col4" },
    expand_col5: { type: String, default: "expand_col5" },
    //擴充欄位_value
    expand_col1_value: { type: String, default: "" },
    expand_col2_value: { type: String, default: "" },
    expand_col3_value: { type: String, default: "" },
    expand_col4_value: { type: String, default: "" },
    expand_col5_value: { type: String, default: "" },
  },
  methods: {
    checkDateFormat(value) {
      let validateEmptyA = /\d{4}\-/g;
      let validateEmptyB = /\d{4}\//g;
      if (
        !value ||
        value === "" ||
        value === "— —" ||
        !(validateEmptyA.test(value) || validateEmptyB.test(value))
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltip-text {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: black;
  text-align: left;
  border-radius: 6px;
  /* padding: 5px 0; */
  position: absolute;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: Arial, Helvetica, sans-serif;
  padding: 20px !important;
  border: 1px solid #c2c4c7;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
/* Tooltip top content */
.top .tooltip-text {
  bottom: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip right content */
.right .tooltip-text {
  top: -5px;
  left: 110%;
}
/* Tooltip bottom content */
.bottom .tooltip-text {
  top: 100%;
  left: 50%;
  margin-left: -140px; /* 120/2 = 60 */
}
/* Tooltip left content */
.left .tooltip-text {
  top: -5px;
  right: 110%;
}
.tooltip .tooltip-text::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
/* Tooltip top arrow */
.top .tooltip-text::after {
  margin-left: -5px;
  left: 50%;
  top: 100%;
  border-color: #fff transparent transparent transparent;
}
/* Tooltip bottom arrow */
.bottom .tooltip-text::after {
  margin-left: -5px;
  bottom: 100%;
  left: 50%;
  border-color: transparent transparent #fff transparent;
}
/* Tooltip left arrow */
.left .tooltip-text::after {
  top: 50%;
  margin-top: -5px;
  left: 100%;
  border-color: transparent transparent transparent #fff;
}
/* Tooltip right arrow */
.right .tooltip-text::after {
  top: 50%;
  margin-top: -40px;
  right: 100%;
  border-color: transparent #fff transparent transparent;
}
.tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
